import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { CtaButton } from "./ui";
import { checkout } from "../data/content";
export const LIGHTBOX_EVENT = "sah:lightbox";
export function StickyOfferBar() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const hero = document.getElementById("hero");
    const offer = document.getElementById("offer-details");
    function onScroll() {
      const limit = hero ? hero.offsetTop + hero.offsetHeight * 0.7 : 400;
      setPastHero(window.scrollY > limit);
    }
    function onLightbox(e: Event) {
      setLightboxOpen(Boolean((e as CustomEvent<boolean>).detail));
    }
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener(LIGHTBOX_EVENT, onLightbox);
    let observer: IntersectionObserver | undefined;
    if (offer) {
      observer = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
        threshold: 0.1
      });
      observer.observe(offer);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener(LIGHTBOX_EVENT, onLightbox);
      observer?.disconnect();
    };
  }, []);
  const show = pastHero && !offerVisible && !lightboxOpen;
  return <AnimatePresence data-id="element-196" data-mp="1ce9tijis0uy0">
      {show && <motion.div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white px-4 py-3 shadow-[0_-8px_24px_rgba(22,78,85,0.1)]" initial={reduceMotion ? {
      opacity: 0
    } : {
      y: "100%"
    }} animate={reduceMotion ? {
      opacity: 1
    } : {
      y: 0
    }} exit={reduceMotion ? {
      opacity: 0
    } : {
      y: "100%"
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-197" data-mp="1cd89hpjs8y45">
          <div className="mx-auto flex max-w-[1144px] items-center justify-between gap-3" data-id="element-198" data-mp="1w3tsz3cz4qtd">
            <p className="min-w-0 truncate text-sm font-semibold text-ink sm:text-base" data-id="element-199" data-mp="25xptyz2corw4">
              The Activity Kit · ${checkout.price} {checkout.currency}
            </p>
            <CtaButton href="#offer-details" compact data-id="element-200" data-mp="1vz9yyl07cyhc">
              See the offer
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}